export default "__VITE_ASSET__5cc24ee9__"